export default __webpack_public_path__ + "static/imprint-41a04898c33f4b6ec4a5ebea8e9296a4.png";